import Header, { IHeader } from "./header"
import Main, { IMain } from "./main"
import styles from "./styles.module.scss"
interface ILayout extends React.FC<React.PropsWithChildren> {
  Header: React.FC<IHeader>
  Main: IMain
}

const Layout: ILayout = ({ children }) => {
  return <div className={styles.layout}>{children}</div>
}

Layout.Header = Header
Layout.Main = Main

export default Layout
